
import React from 'react';

const OrderTracking = ({ statuses, currentStatus }) => {
    
  return (
    <div className="flex items-center justify-between w-full px-4">
      {statuses?.map((status, index) => {
        const isActive = statuses?.indexOf(currentStatus) >= index;
        const isCurrent = currentStatus === status;

        return (
          <div key={status} className="flex flex-1 flex-col items-center relative">
            {/* Connector line */}
            {index !== 0 && (
              <div
                className={`absolute -left-1/2 top-4 h-1 w-full ${
                  isActive ? 'bg-blue-500' : 'bg-gray-300'
                }`}
              ></div>
            )}

            {/* Status Node */}
            <div
              className={`flex items-center justify-center w-8 h-8 z-10 rounded-full ${
                isCurrent
                  ? 'bg-blue-500 text-white'
                  : isActive
                  ? 'bg-blue-100 text-blue-500'
                  : 'bg-gray-300 text-gray-500'
              }`}
            >
              {index + 1}
            </div>

            {/* Status Label */}
            <span
              className={`mt-2 text-sm ${
                isActive ? 'text-blue-500' : 'text-gray-500'
              }`}
            >
              {status}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default OrderTracking;

